import { ITableHeaders } from '@Models/common.model'

export const firearmHeaders: ITableHeaders[] = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Image',
        key: 'image',
        formatType: 'image',
        className: 'text-center',
    },
    {
        name: 'Serial Number',
        key: 'serialNumber',
    },
    {
        name: 'FFL',
        key: 'ffl',
    },

    {
        name: 'Make',
        key: 'make',
    },
    {
        name: 'Model',
        key: 'model',
    },
    {
        name: 'Caliber',
        key: 'caliber',
    },
    {
        name: 'Platform',
        key: 'platform',
    },
    {
        name: 'Gun Type',
        key: 'type',
    },
]

export const insuranceHeaders: ITableHeaders[] = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Start Date',
        key: 'startDate',
    },
    {
        name: 'End Date',
        key: 'endDate',
    },
    {
        name: 'Telphone',
        key: 'phone',
    },

    {
        name: 'Address',
        key: 'address',
    },
    {
        name: 'City',
        key: 'city',
    },
    {
        name: 'State',
        key: 'state',
    },
    {
        name: 'Zip Code',
        key: 'zipCode',
    },
    {
        name: 'Policy',
        key: 'policy',
    },
]
export const inspectionHeaders: ITableHeaders[] = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Insp Start Date',
        key: 'startDate',
    },
    {
        name: 'Insp End Date',
        key: 'endDate',
    },
]

export const safeStorageHeaders: ITableHeaders[] = [
    // {
    //     name: 'ID',
    //     key: 'id',
    // },
    {
        name: 'User ID',
        key: 'userId',
    },
    {
        name: 'End Safe Serial',
        key: 'endSafeSerial',
    },
    {
        name: 'Safe Make',
        key: 'safeMake',
    },
    {
        name: 'Safe Model',
        key: 'safeModel',
    },
    {
        name: 'Safe Type H and G',
        key: 'safeType',
    },
]

export const accessoryHeaders: ITableHeaders[] = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Image',
        key: 'image',
        formatType: 'image',
        className: 'text-center',
    },
    {
        name: 'FFL',
        key: 'ffl',
    },
    {
        name: 'Make',
        key: 'make',
    },
    {
        name: 'Model',
        key: 'model',
    },
    {
        name: 'Caliber',
        key: 'caliber',
    },
]
export const partHeaders: ITableHeaders[] = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Image',
        key: 'image',
        formatType: 'image',
        className: 'text-center',
    },
    {
        name: 'FFL',
        key: 'ffl',
    },
    {
        name: 'Component',
        key: 'component',
    },
    {
        name: 'Serial Number',
        key: 'serial',
    },
]

export const ammunitionHeaders: ITableHeaders[] = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Image',
        key: 'image',
        formatType: 'image',
        className: 'text-center',
    },
    {
        name: 'Make',
        key: 'make',
    },
    {
        name: 'Qty',
        key: 'qty',
        className: 'text-center',
    },
    {
        name: 'Date Purchase',
        key: 'DatePurchase',
    },
    {
        name: 'Qmicrostamp',
        key: 'qmicrostamp',
    },
    {
        name: 'FFL',
        key: 'ffl',
    },
    {
        name: 'Caliber',
        key: 'caliber',
    },
]
export const invoiceHeaders: ITableHeaders[] = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Qty',
        key: 'qty',
        className: 'text-center',
    },
    {
        name: 'Sub Total Amount',
        key: 'subTotalAmount',
        className: 'text-right',
        formatType: 'currency',
    },
    {
        name: 'Total Discount Amount',
        key: 'totalDiscountAmount',
        className: 'text-right',
        formatType: 'currency',
    },
    {
        name: 'Total Amount',
        key: 'totalAmount',
        className: 'text-right',
        formatType: 'currency',
    },
]
